import exam from '../assets/examMap.json';
import licenseDetails from '../assets/licenseDetails.json';
import questions1 from '../assets/questions.json';
import reviewTopics from '../assets/reviewTopics.json';
import { default as b1, default as b2, default as c } from '../data/mapping-json/a1.json';
import a2 from '../data/mapping-json/a2.json';
import a34 from '../data/mapping-json/a34.json';
import questions from '../data/mapping-json/questions.json';

function topics() {
  const reviewTopicsFinal = [];
  licenseDetails.forEach((item1) => {
    reviewTopicsFinal.push(reviewTopics[item1.id]);
  });
  return reviewTopicsFinal;
}

function convertQuiz(length, nameQuiz) {
  const quizs = [];
  for (let i = 1; i <= length; i++) {
    const listQuestions = [];
    const qid = nameQuiz.filter((item) => item.eid === i);
    qid.map((item) => {
      const question = questions.find((c) => c?.id === parseInt(item.qid, 10));
      listQuestions.push(question);
    });
    quizs.push(listQuestions);
  }
  return quizs;
}

function convert(length, nameQuiz) {
  const quizs = [];
  for (let i = 1; i <= length; i++) {
    const listQuestions = [];
    nameQuiz[i].map((item) => {
      const question = questions1[item[0]];
      listQuestions.push(question);
    });
    quizs.push(listQuestions);
  }
  return quizs;
}

function convertQuizRandom(arr) {
  const quizs = [];
  for (let i = 0; i < arr.length; i++) {
    const question = questions1[arr[i][0]];
    quizs.push(question);
  }
  return quizs;
}

function convert1(nameQuiz) {
  const allQuiz = [];
  for (let i = 0; i < nameQuiz.length; i++) {
    const quiz = [];
    for (let j = 1; j < nameQuiz[i].length; j++) {
      const listQuestions = [];
      nameQuiz[i][j].map((item) => {
        const question = questions1[item[0]];
        listQuestions.push(question);
      });
      quiz.push(listQuestions);
    }
    allQuiz.push(quiz);
  }
  return allQuiz;
}

export function MapLicense(selectLicense) {
  if (selectLicense === 'a1') {
    return convert(8, exam[0]);
  }
  if (selectLicense === 'a2') {
    const length = 8;
    return convertQuiz(length, a2);
  }
  if (selectLicense === 'a3') {
    const length = 8;
    return convertQuiz(length, a34);
  }
  if (selectLicense === 'a4') {
    const length = 8;
    return convertQuiz(length, a34);
  }
  if (selectLicense === 'b1') {
    const length = 8;
    return convertQuiz(length, b1);
  }
  if (selectLicense === 'b2') {
    const length = 8;
    return convertQuiz(length, b2);
  }
  if (selectLicense === 'c') {
    const length = 8;
    return convertQuiz(length, c);
  }
}

export function listTopics() {
  return topics();
}

function convertSurprise(arr) {
  const quizs = [];
  arr.map((item) => {
    const question = questions1[item[0]];
    quizs.push(question);
  });

  return quizs;
}

function convertTopic(arr) {
  const listQuiz = [];
  for (let i = 0; i < arr.length; i++) {
    const quizs = convertSurprise(arr[i].indexes);
    listQuiz.push(quizs);
  }
  return listQuiz;
}

function convertSurpriseInExam(arr1, arr2) {
  const arrSurprise = [];
  const arrIndexQuestion = [];
  for (let i = 0; i < arr1.length; i++) {
    for (let j = 0; j < arr2.length; j++) {
      if (arr1[i]?.q === arr2[j]?.q) {
        arrSurprise.push(arr1[i]);
        arrIndexQuestion.push(i);
      }
    }

  }
  return [arrSurprise, arrIndexQuestion];
}

export function surpriseInExam(arr1, arr2) {
  return convertSurpriseInExam(arr1, arr2);
}

export function topic(array) {
  return convertSurprise(array);
}

export function listTopic(array) {
  return convertTopic(array);
}

export function quizRandom(array) {
  return convertQuizRandom(array);
}

export function allQuiz() {
  const arr = [];
  for (let i = 0; i < convert1(exam).length; i++) {
    const quiz = [];
    for (let j = 0; j < convert1(exam)[i].length; j++) {
      quiz.push(convert1(exam)[i][j]);
    }
    arr.push(quiz);
  }
  return arr;
}
